export class FileUtil {

	constructor() {
	}

	static formatFileSize(bytes: number): string {
		if (bytes <= 0) {
			return '0 Bytes';
		}
		const BASE_1024 = 1024;
		const sizes = ['Bytes', 'KB', 'MB', 'GB'];
		const index = Math.min(Math.floor(Math.log(bytes) / Math.log(BASE_1024)), sizes.length - 1);
		return parseFloat((bytes / Math.pow(BASE_1024, index)).toFixed(2)) + ' ' + sizes[index];
	}

	static downloadFileDirectly(url: string) {
		const anchor = document.createElement('a');
		anchor.href = url;
		anchor.download = '';
		anchor.style.display = 'none';
		document.body.appendChild(anchor);
		anchor.click();
		document.body.removeChild(anchor);
	}
}
